import { render, staticRenderFns } from "./ChipsAutocomplete.vue?vue&type=template&id=110529b9&"
import script from "./ChipsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ChipsAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports